<template>
  <div>
    <Row>
      <Form ref="queryTrimForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Select v-model="query.areaId" filterable style="width:150px;margin-right: 10px;" placeholder="请选择修剪区域">
          <Option v-for="item in list.data1" :value="item.id" :key="item.id" >{{ item.name }}</Option>
        </Select>
        <Select v-model="query.trimPeople" filterable style="width:150px;margin-right: 10px;" placeholder="请选择修剪人">
          <Option v-for="item in list.data2" :value="item.id" :key="item.id" >{{ item.name }}</Option>
        </Select>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openTrimDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="trimTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <!--<div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.trimTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="trimDrawer" :title="this.$t('drawer.title')[trimDrawer.type]" :visible.sync="trimDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <trim-form ref="trimForm"/>
        <div class="right-drawer__footer" v-if="trimDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="trimDrawer.submiting">{{ trimDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="trimDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import TrimForm from '@/views/property/trim/components/Form.vue';
Vue.component('trim-form', TrimForm);

export default {
  name: 'aip-property-trim-index',
  mixins:[mixin],
  data () {
    return {
      query:{
        areaId: '',
        trimTime: '',
        trimPeople: '',
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      list:{
        loading:false,
        data1:[],
        data2:[],
      },
      model12:[],
      trimDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  created(){
    this.handleAreaList()
    this.handlePeopleList()
  },
  methods: {
    handleBatchOperate(){
      let records = this.$refs.trimTable.getSelection()
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    },
    handleSearch(){
      this.page.loading = true;
      api.property.Trim.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openTrimDrawer(trim){
      this.trimDrawer.visible = true
      this.trimDrawer.type = trim ? trim.type : 'add'
      this.$nextTick(()=>{
          if(trim){
              this.$refs['trimForm'].getTrim(trim.id,trim.type)
          }else{
            this.$refs['trimForm'].handleReset()
          }
      })
    },
    handleAreaList(){
      this.loading = true;
      api.property.GreenArea.listAreaInfo()
        .then(data=>{
          console.log(data);
          this.list.data1 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handlePeopleList(){
      this.loading = true;
      api.property.Employees.listEmployeesInfo()
        .then(data=>{
          console.log(data);
          this.list.data2 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handleSubmit(){
        this.trimDrawer.submiting = true;
        this.$refs.trimForm.handleSubmit(
          data=>{
            this.trimDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.trimDrawer.visible=false, 1000);
          },
          ()=>{
            this.trimDrawer.submiting = false;
          }
        )
    },
    deleteTrim(id){
      api.property.Trim.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.property.Trim.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},

           {key: 'areaId',
            align:'left',
            minWidth: 120,
            fixed:'left',
            title:  this.$t('property.trim.areaId.label'),
             render: (h, params) => {
               let json = JSON.stringify(params.row.greenArea.name);
               let str = json.substring(1,json.length-1);
               return <div>{str}</div>
             }
            },
          {key: 'trimTime', align: 'center', width:170, title: this.$t('property.trim.trimTime.label'),},
          {key: 'trimPeople',
            align:'left',
            minWidth: 120,
            title:  this.$t('property.trim.trimPeople.label'),
            render: (h, params) => {
              let json = JSON.stringify(params.row.employees.name);
              let str = json.substring(1,json.length-1);
              return <div>{str}</div>
            }
          },
          {key: 'remark', align:'left',minWidth: 120, title:  this.$t('property.trim.remark.label')},
          {key: 'createTime', align: 'center', width:170, title: this.$t('property.trim.createTime.label'),},
        /*{
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openTrimDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openTrimDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                      onOn-ok={()=>this.deleteTrim(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }*/
      ]
    }
  }
}
</script>
